import { createSlice } from '@reduxjs/toolkit'

const initialState = window.INITIAL_STATE?.properties || {}

const slice = createSlice({
	name: 'properties',
	initialState,
	reducers: {
		// none yet
	},
})

// export const { start, success, error } = slice.actions

export default slice.reducer
